// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Modal_overlay__UDmdY","modal":"Modal_modal__tgf_Y"};